import React, { FC, useEffect } from "react";
import { Card, Col, Row, Tag } from "antd";
import { useParams } from "react-router-dom";
import Info from "../../../components/CI10/Info";
import Instruments from "../../../components/CI10/Instruments";
import News from "../../../components/CI10/News";
import Tabs from "../../../components/CI10/Tabs";
import SiteSponsors from "../../../components/CI10/SiteSponsors";
import { useActions } from "../../../hooks/useActions";
import { useTypedSelector } from "../../../hooks/useTypedSelector";
import useHttpGet from "../../../hooks/useHttpGet";
import { APIRoutes } from "../../../http";
import { IResultResponse } from "../../../models/response/result.model";
import { ICryptoIndex } from "../../../models/cryptoindex.model";

const CI10: FC = () => {
  const { id } = useParams();
  const indexId = useTypedSelector(({ ci }) => ci.indexId);
  const { setIndexId } = useActions();

  useEffect(() => {
    const indexId = !!id ? parseInt(id) : 1;
    setIndexId(indexId);
  }, [id]);

  const { fetchedData, loading } = useHttpGet<IResultResponse<ICryptoIndex>>(
    `${APIRoutes.CRYPTO_INDEX}/${indexId}`,
    {
      dependencies: [indexId],
      condition: indexId > 0,
    }
  );

  return (
    <Row justify="center" align="top">
      <Col xs={24} sm={24} md={20}>
        <Card
          className="custom-card-1"
          title={
            <div className="d-flex align-items-center">
              <span className="mr-0_5 fs-36">{fetchedData?.result?.name}</span>
              <Tag>{fetchedData?.result?.ticker}</Tag>
            </div>
          }
        >
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col xs={24} sm={24} md={9}>
              <Info />
            </Col>
            <Col xs={24} sm={24} md={15}>
              {fetchedData?.result &&
                <Tabs index={fetchedData.result} />
              }
            </Col>
          </Row>

          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }} className="mt-2">
            <Col xs={24} sm={24} md={15}>
              {fetchedData?.result &&
                <Instruments index={fetchedData.result} />
              }
            </Col>
            <Col xs={24} sm={24} md={9}>
              <News />
            </Col>
            <Col span={24}>
              <SiteSponsors />
            </Col>
          </Row>
        </Card>
      </Col>
    </Row>
  );
};

export default CI10;
